import { globalMessageApi } from "@obsbot/remo-server-api";
import { MessageInstance } from "antd/es/message/interface";
import React, { ComponentType } from "react";
export const withMessage = <T extends object>(
    WrappedComponent: ComponentType<T & { message: MessageInstance }>,
) => {
    return function WithMessageComponent(props: T) {
        // 移除 message.useMessage() 的调用，因为我们将使用全局 messageApi
        // const [messageApi, contextHolder] = message.useMessage({
        //     maxCount: 2,
        //     duration: 20,
        // });

        return (
            <>
                {/* contextHolder 也不再需要，因为全局 messageApi 不会返回 contextHolder */}
                {/* {contextHolder} */}
                <WrappedComponent {...props} message={globalMessageApi} />
            </>
        );
    };
};
